const config = {
    basename: '',
    defaultPath: '/dashboard',
    fontFamily: `'Asap', normal`,
    borderRadius: 12
};

export default config;
